import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { Button, FormInput, FormTextarea, Modal } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { copyTextToClipboard } from 'shared/utils/copy-text-to-clipboard';
import { FunnelStepId } from '../../../types/funnel-step-interface';
import { getScriptLinkHtmlCode } from '../../../utils/remote-form-utils';
interface CreateRemotePopupLinkModalProps {
  opened: boolean;
  onClose: () => void;
  domainName: string;
  pageHash: string;
  funnelStepId: FunnelStepId;
}
const CreateRemotePopupLinkModal = t0 => {
  const $ = _c(43);
  const {
    opened,
    onClose,
    domainName,
    pageHash,
    funnelStepId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.configuration.remote.anchor_name_placeholder");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaultAnchorName = t1;
  const [tempAnchorName, setTempAnchorName] = useState(defaultAnchorName);
  let t2;
  if ($[2] !== domainName || $[3] !== funnelStepId || $[4] !== pageHash || $[5] !== tempAnchorName) {
    t2 = getScriptLinkHtmlCode(domainName, pageHash, funnelStepId, tempAnchorName);
    $[2] = domainName;
    $[3] = funnelStepId;
    $[4] = pageHash;
    $[5] = tempAnchorName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [tempLink, setTempLink] = useState(t2);
  let t3;
  if ($[7] !== domainName || $[8] !== funnelStepId || $[9] !== pageHash || $[10] !== tempAnchorName) {
    t3 = () => {
      setTempLink(getScriptLinkHtmlCode(domainName, pageHash, funnelStepId, tempAnchorName));
    };
    $[7] = domainName;
    $[8] = funnelStepId;
    $[9] = pageHash;
    $[10] = tempAnchorName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== tempAnchorName) {
    t4 = [tempAnchorName];
    $[12] = tempAnchorName;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  useEffect(t3, t4);
  let t5;
  if ($[14] !== defaultAnchorName || $[15] !== onClose) {
    t5 = () => {
      onClose();
      setTempAnchorName(defaultAnchorName);
    };
    $[14] = defaultAnchorName;
    $[15] = onClose;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t) {
    t6 = t("dashboard.funnel.configuration.remote.modal_link_header");
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t) {
    t7 = t("dashboard.funnel.configuration.remote.anchor");
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => setTempAnchorName(e.target.value);
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== tempAnchorName) {
    t9 = <FormInput label={t7} value={tempAnchorName} onChange={t8} />;
    $[22] = t7;
    $[23] = tempAnchorName;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== tempLink) {
    t10 = <div className="flex flex-col justify-center gap-3"><FormTextarea value={tempLink} disabled={true} /></div>;
    $[25] = tempLink;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== tempLink) {
    t11 = async e_0 => {
      e_0.preventDefault();
      await copyTextToClipboard(tempLink);
    };
    $[27] = tempLink;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("global.copy_to_clipboard_caption");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12) {
    t13 = <div className="tablet:[&>*]:flex-none tablet:[&>*]:w-auto flex justify-end gap-3 [&>*]:flex-1"><Button onClick={t11} variant="primary" size="md">{t12}</Button></div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t10 || $[35] !== t13 || $[36] !== t9) {
    t14 = <form className="desktop:gap-10 flex flex-col gap-6">{t9}{t10}{t13}</form>;
    $[34] = t10;
    $[35] = t13;
    $[36] = t9;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== opened || $[39] !== t14 || $[40] !== t5 || $[41] !== t6) {
    t15 = <Modal opened={opened} onClose={t5} title={t6}>{t14}</Modal>;
    $[38] = opened;
    $[39] = t14;
    $[40] = t5;
    $[41] = t6;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
};
export default CreateRemotePopupLinkModal;